export default __webpack_public_path__ + "static/GooglePay-4fb58c0b.svg";